export default {
  ios: (): boolean => {
    return /ipad|iphone|ipod/i.test(navigator.userAgent);
  },
};
